import type { Messages } from '../types';

export const es: Messages = {
  common: {
    cancel: 'Cancelar',
    save: 'Guardar',
    delete: 'Eliminar',
    edit: 'Editar',
    create: 'Crear',
    loading: 'Cargando…',
    copy: 'Copiar',
    ok: 'Aceptar',
    close: 'Cerrar',
    or: 'o',
    creating: 'Creando...',
    unknownError: 'Error desconocido',
    none: 'Ninguno',
    color: 'Color',
    visible: 'Visible',
    locked: 'Bloqueado',
    hide: 'Ocultar',
    show: 'Mostrar',
    lock: 'Bloquear',
    unlock: 'Desbloquear',
    update: 'Actualizar',
  },
  language: {
    label: 'Idioma',
  },
  auth: {
    welcome:
      'Bienvenido a tween.studio — diseña movimiento, crea escenas y da vida a tus historias.',
    email: 'Correo electrónico',
    password: 'Contraseña',
    emailPlaceholder: 'tu@ejemplo.com',
    name: 'Nombre',
    surname: 'Apellido',
    namePlaceholder: 'Ada',
    surnamePlaceholder: 'Lovelace',
    confirmPassword: 'Confirmar contraseña',
    termsOfService: 'Términos de servicio',
    privacyPolicy: 'Política de privacidad',
    and: 'y',
    signInTitle: 'Iniciar sesión',
    signInSubtitle: 'Continúa donde lo dejaste.',
    signIn: 'Iniciar sesión',
    signingIn: 'Iniciando sesión...',
    noAccount: '¿No tienes una cuenta?',
    signUp: 'Regístrate',
    loginFailed: 'Error al iniciar sesión',
    googleSignInFailed: 'Error al iniciar sesión con Google',
    googleSignInLoadFailed: 'No se pudo cargar el inicio de sesión con Google',
    continueWithFacebook: 'Continuar con Facebook',
    continueWithInstagram: 'Continuar con Instagram',
    metaSignInComingSoon:
      'El inicio de sesión con {brand} usa Meta Login — la conexión llega pronto. El proveedor se puede configurar en admin.',
    createAccountTitle: 'Crear cuenta',
    createAccountSubtitle: 'Únete a tween.studio y empieza a animar.',
    createAccount: 'Crear cuenta',
    creatingAccount: 'Creando cuenta...',
    hasAccount: '¿Ya tienes una cuenta?',
    signInLink: 'Inicia sesión',
    termsAgreePrefix: 'Al crear una cuenta aceptas nuestros',
    termsAgreeSuffix: '.',
    passwordMinLength: 'La contraseña debe tener al menos 6 caracteres.',
    passwordsDoNotMatch: 'Las contraseñas no coinciden.',
    registrationFailed: 'Error al registrarse',
  },
  theme: {
    label: 'Tema',
    light: 'Claro',
    dark: 'Oscuro',
    system: 'Sistema',
    switchToLight: 'Cambiar a modo claro',
    switchToDark: 'Cambiar a modo oscuro',
  },
  connection: {
    Connected: 'Conectado',
    Connecting: 'Conectando',
    Reconnecting: 'Reconectando',
    Disconnected: 'Desconectado',
    Error: 'Error',
  },
  toolbar: {
    selectMovie: 'Seleccionar película',
    ai: 'IA',
    notifications: 'Notificaciones',
    loadingNotifications: 'Cargando notificaciones...',
    noNotifications: 'Aún no hay notificaciones.',
    zoom: 'Zoom',
    zoomLevel: 'Nivel de zoom',
    zoomIn: 'Acercar',
    zoomOut: 'Alejar',
    zoomPercent: 'Zoom {percent}%',
    shapes: 'Formas',
    objects3d: 'Objetos 3D',
    characters: 'Personajes',
    characterPresets: {
      humanoid: 'Humano',
      animal: 'Animal',
      turtle: 'Tortuga',
      octopus: 'Pulpo',
    },
    sceneEffects: 'Efectos de escena',
    sceneEffectsLabel: 'Efectos de escena',
    activeEffects: '{count} efectos activos',
    clearAllEffects: 'Borrar todos los efectos',
    tools: {
      select: 'Seleccionar (V)',
      pan: 'Mano (H, mantén Space)',
      line: 'Línea (L)',
      curve: 'Curva (P)',
      text: 'Texto (T)',
      rectangle: 'Rectángulo (R)',
      circle: 'Círculo (C)',
      triangle: 'Triángulo',
      polygon: 'Polígono (G)',
      cube3d: 'Cubo 3D',
      sphere3d: 'Esfera 3D',
      box3d: 'Caja 3D',
      cylinder3d: 'Cilindro 3D',
      prism3d: 'Prisma 3D',
      mesh3d: 'Malla 3D',
      fog: 'Niebla',
      rain: 'Lluvia',
      snow: 'Nieve',
      lightning: 'Rayo',
      particles: 'Partículas',
      vignette: 'Viñeta',
    },
  },
  movieSelector: {
    newMovie: 'Nueva película',
    createNewMovie: 'Crear nueva película',
    movieNamePlaceholder: 'nombre de la película...',
    movieDescriptionPlaceholder: 'descripción de la película...',
    recent: 'Recientes',
    myProjects: 'Mis proyectos',
    sampleMovies: 'Películas de ejemplo',
    currentMovie: 'Película actual',
    unloadMovie: 'Cerrar película',
    closeMovie: 'Cerrar película',
    deleteMovie: 'Eliminar película',
    moreActions: 'Más acciones',
    selectToPreview: 'Selecciona una película para previsualizar',
    deleteConfirmTitle: '¿Eliminar película?',
    deleteConfirmDescription: '"{name}" se eliminará permanentemente.',
    thisMovie: 'Esta película',
    movieAria: 'película',
    today: 'Hoy',
    yesterday: 'Ayer',
    daysAgo: 'Hace {count} días',
    older: 'Más antiguo',
    errors: {
      idUnresolved: 'No se pudo resolver el id de la película.',
      nameEmpty: 'El nombre de la película no puede estar vacío.',
      saveFailed: 'No se pudo guardar la película. Inténtalo de nuevo.',
    },
  },
  userMenu: {
    ariaLabel: 'Menú de usuario',
    sectionsAria: 'Secciones del menú de usuario',
    tabs: {
      credits: 'Créditos',
      account: 'Cuenta',
      preferences: 'Preferencias',
    },
    administration: 'Administración',
    signOut: 'Cerrar sesión',
    loadingCredits: 'Cargando créditos',
    creditsCount: '{count} créditos',
    credits: {
      currentBalance: 'Saldo actual',
      unit: 'créditos',
      add: 'Añadir créditos',
      hideAdd: 'Ocultar añadir créditos',
      hideAddOptions: 'Ocultar opciones para añadir créditos',
      loadingPurchase: 'Cargando opciones de compra...',
      noCardOptions: 'No hay opciones de pago con tarjeta configuradas.',
      planCredits: '{count} créditos',
      loadWithTether: 'Cargar con Tether (USDT)',
      loadingDeposit: 'Cargando...',
      noUsdtWallet: 'No hay dirección de monedero USDT configurada.',
      rate: '1 {symbol} = {credits} créditos',
      copyAddress: 'Copiar dirección',
      recentTransactions: 'Transacciones recientes',
      loadingTransactions: 'Cargando transacciones...',
      noTransactions: 'Aún no hay transacciones.',
    },
    account: {
      creditUsage: 'Uso de créditos',
      balance: 'Saldo',
      earned: 'Ganados',
      spent: 'Gastados',
      transactions: 'Transacciones',
      changePassword: 'Cambiar contraseña',
      changePasswordTitle: 'Cambiar contraseña',
      currentPassword: 'Contraseña actual',
      currentPasswordHint: 'Déjalo vacío para cuentas solo sociales',
      newPassword: 'Nueva contraseña',
      confirmPassword: 'Confirmar nueva contraseña',
      updatePassword: 'Actualizar contraseña',
      saving: 'Guardando…',
      errors: {
        newRequired: 'La nueva contraseña es obligatoria.',
        minLength: 'La nueva contraseña debe tener al menos 6 caracteres.',
        mismatch: 'La nueva contraseña y la confirmación no coinciden.',
        failed: 'No se pudo cambiar la contraseña.',
      },
      success: 'Contraseña cambiada correctamente.',
    },
  },
  sidebar: {
    collapse: 'Contraer panel',
    expand: 'Expandir panel',
  },
  toolpads: {
    library: {
      title: 'Biblioteca',
      dropImages: 'Suelta imágenes aquí',
      importFiles: 'Importar archivos',
      import: '+ Importar',
      importAria: 'Importar archivos',
      uploading: 'Subiendo…',
      deleteConfirmTitle: '¿Eliminar elemento de la biblioteca?',
      deleteConfirmDescription: '"{name}" se eliminará permanentemente.',
      deleteFailedTitle: 'No se pudo eliminar',
      deleteFailedFallback: 'No se pudo eliminar.',
      inUseTitle: 'Elemento en uso',
      inUseDescription:
        '"{name}" lo usa al menos un objeto de escena ({count}). Quítalo primero de la escena.',
      noLayerTitle: 'No hay capa seleccionada',
      noLayerDescription: 'Selecciona una capa antes de añadir un objeto de escena.',
      mine: 'Proyecto',
      vectorHint: 'Arrastra al escenario o haz doble clic para copiarlo en este proyecto.',
      vectorsEmpty: 'La biblioteca pública está vacía.',
      vectorsLoadFailed: 'No se pudo cargar la biblioteca pública.',
      vectorUseFailed: 'No se pudo añadir este elemento al proyecto.',
    },
    scenes: {
      title: 'Escenas',
      empty: 'Aún no hay escenas.',
      add: '+ Añadir escena',
      defaultName: 'Escena {count}',
      nameAria: 'Nombre de la escena',
      dragReorder: 'Arrastra para reordenar',
      deleteTitle: 'Eliminar escena',
      deleteDescription: 'Se eliminará "{name}".',
      deleteTooltip: 'Eliminar escena',
      cannotDeleteTitle: 'No se puede eliminar la escena',
      cannotDeleteLast: 'Una película debe conservar al menos una escena. La última no se puede eliminar.',
      createFailed: 'No se pudo crear la escena: {error}',
      deleteFailed: 'No se pudo eliminar la escena: {error}',
    },
    sceneObjects: {
      title: 'Objetos de escena',
      empty: 'Añade objetos a la escena arrastrándolos desde la biblioteca.',
      selectAll: 'Seleccionar todo',
      selectAllAria: 'Seleccionar todos los objetos de escena',
      selectedCount: '{count} seleccionados',
      expand: 'Expandir',
      collapse: 'Contraer',
      objectNameAria: 'Nombre del objeto',
      selectObject: 'Seleccionar {name}',
      selectObjectAndChildren: 'Seleccionar {name} y sus hijos',
      deselectObjectAndChildren: 'Deseleccionar {name} y sus hijos',
      selectAllChildren: 'Seleccionar todos los hijos',
      all: 'Todos',
    },
    sceneEffects: {
      title: 'Efectos de escena',
      empty: 'Activa efectos de escena desde la barra de herramientas para ajustar sus parámetros aquí.',
      activeCount: '{count} activos',
      clearAll: 'Borrar todo',
      expand: 'Expandir parámetros',
      collapse: 'Contraer parámetros',
      enable: 'Activar efecto',
      disable: 'Desactivar efecto',
      params: {
        intensity: 'Intensidad',
        speed: 'Velocidad',
        particleSize: 'Tamaño de partícula',
        color: 'Color',
      },
    },
    clipFolders: {
      title: 'Carpetas de clips',
      empty: 'No hay carpetas de clips.',
      add: '+ Añadir carpeta',
      defaultName: 'Carpeta {count}',
      deleteTooltip: 'Eliminar carpeta',
    },
    movieProperties: {
      title: 'Propiedades de la película',
      stageSize: 'Tamaño del escenario',
      width: 'An',
      height: 'Al',
      frameRate: 'Velocidad de fotogramas',
      frameRateAria: 'Velocidad de fotogramas',
      fpsOption: '{count} FPS',
      info: 'Info',
      name: 'Nombre: ',
      scenes: 'Escenas: ',
      noMovie: 'No hay película cargada.',
      publish: 'Publicar',
      publishing: 'Publicando…',
      publishHint: 'Crea una instantánea de solo lectura para el reproductor público.',
      linkCopied: 'Enlace del reproductor copiado.',
    },
  },
  rightSidebar: {
    style: {
      title: 'Estilo',
      selectObject: 'Selecciona un objeto en el escenario para ajustar los colores.',
      shapeOrTextOnly: 'Los ajustes de estilo se aplican a formas, texto e imágenes.',
      text: 'Texto',
      textColor: 'Color del texto',
      fontSize: 'Tamaño de fuente',
      fontSizeAria: 'Tamaño de fuente',
      fontSizePxAria: 'Tamaño de fuente px',
      align: 'Alinear',
      textAlignAria: 'Alineación del texto',
      left: 'Izquierda',
      center: 'Centro',
      right: 'Derecha',
      justify: 'Justificar',
      colors: 'Colores',
      fill: 'Relleno',
      fillModeAria: 'Modo de relleno',
      fillSolid: 'Color',
      fillGradient: 'Degradado',
      fillColor: 'Color de relleno',
      gradientStart: 'Inicio',
      gradientEnd: 'Fin',
      gradientAngle: 'Ángulo',
      gradientAngleAria: 'Ángulo del degradado',
      border: 'Borde',
      borderTypeAria: 'Tipo de borde',
      borderColor: 'Color del borde',
      borderSizeAria: 'Tamaño del borde',
      size: 'Tamaño',
      sides: 'Lados',
      sidesAria: 'Lados del borde',
      sideTop: 'Arriba',
      sideRight: 'Derecha',
      sideBottom: 'Abajo',
      sideLeft: 'Izquierda',
      solid: 'Sólido',
      dashed: 'Discontinuo',
      dotted: 'Punteado',
      fillBorderConflict: 'El relleno y el borde no pueden ser ninguno a la vez.',
      effects: 'Efectos',
      shadow: 'Sombra',
      shadowColor: 'Color de sombra',
      shadowOffsetX: 'Desplazamiento X',
      shadowOffsetY: 'Desplazamiento Y',
      shadowBlur: 'Desenfoque',
      shadowSpread: 'Extensión',
      glow: 'Resplandor',
      glowColor: 'Color de resplandor',
      glowBlur: 'Desenfoque de resplandor',
      enabled: 'Sí',
      disabled: 'No',
    },
    properties: {
      title: 'Propiedades',
      object: 'Objeto',
      tween: 'Tween',
      transform: 'Transformar',
      stageTools: 'Herramientas del escenario',
      stageResize: 'Resize',
      stageRotate: 'Rotate',
      stageResizeHint: 'Mostrar controladores de tamaño en el objeto seleccionado',
      stageRotateHint: 'Mostrar controladores de rotación en las esquinas y el pivote',
      pivotHint: 'Arrastra para definir el pivote / articulación',
      keepAspectRatio: 'Mantener proporción',
      keepAspectRatioHint: 'También se activa temporalmente al redimensionar con Shift.',
      appearance: 'Apariencia',
      rotation: 'Rotación',
      rotationAria: 'Rotación',
      rotationDegreesAria: 'Grados de rotación',
      opacity: 'Opacidad',
      opacityAria: 'Opacidad',
      opacityPercentAria: 'Porcentaje de opacidad',
      visibility: 'Visibilidad',
      activeTween: 'Tween activo ({start} → {end})',
      easing: 'Suavizado',
      easingAria: 'Tipo de suavizado',
      linear: 'Linear',
      easeIn: 'Ease In',
      easeOut: 'Ease Out',
      easeInOut: 'Ease In-Out',
      bounce: 'Bounce',
      elastic: 'Elastic',
      back: 'Back',
      noTween: 'No hay tween en el fotograma actual.',
      noTweenHint: 'Crea dos keyframes y añade un tween entre ellos.',
      allTweens: 'Todos los tweens',
      frameRange: 'Fotograma {start} → {end}',
      noSelection: 'Selecciona algo en la Escena o la Línea de tiempo para ver y editar sus propiedades.',
      selectedObjects: '{count} objetos seleccionados',
      selectedObjectAria: 'Objeto a editar en la selección',
      keyframe: 'Keyframe',
      frame: 'Fotograma:',
      activeKeyframe: '◆ Keyframe activo: Fotograma {frame}',
      noKeyframe: 'No hay keyframe en o antes del fotograma actual',
      selectFrameHint: 'Selecciona un fotograma en la línea de tiempo',
      createKeyframe: 'Crear keyframe',
      updateKeyframe: 'Actualizar keyframe',
      stateObjects: 'Objetos que llevan el estado',
      noStateObjects: 'Este keyframe no lleva estado de objetos.',
      copyStateToPrevious: 'Copiar estado al keyframe anterior ({frame})',
      copyStateToNext: 'Copiar estado al keyframe siguiente ({frame})',
      noPreviousKeyframe: 'No hay keyframe anterior',
      noNextKeyframe: 'No hay keyframe siguiente',
    },
    align: {
      title: 'Alinear',
      horizontal: 'Horizontal',
      vertical: 'Vertical',
      left: 'Alinear a la izquierda',
      center: 'Centrar',
      right: 'Alinear a la derecha',
      top: 'Alinear arriba',
      middle: 'Alinear al medio',
      bottom: 'Alinear abajo',
    },
  },
  timeline: {
    prevFrame: 'Fotograma anterior (,)',
    pause: 'Pausa (Space)',
    play: 'Reproducir (Space)',
    playNeedsKeyframe: 'Se necesita al menos un keyframe para reproducir',
    stop: 'Detener (.)',
    nextFrame: 'Fotograma siguiente (.)',
    addKeyframe: 'Añadir keyframe (F6)',
    deselectKeyframe: 'Deselecciona el keyframe para añadir en el playhead',
    keyframeExists: 'Ya existe un keyframe en el fotograma actual',
    deleteKeyframe: 'Eliminar keyframe',
    addTween: 'Añadir tween (F7)',
    addTweenHint: 'Se puede añadir entre dos keyframes cuando no hay tween',
    deleteTween: 'Eliminar tween',
    frame: 'Fotograma:',
    time: 'Tiempo:',
    total: 'Total:',
    totalFramesAria: 'Fotogramas totales',
    addLayer: 'Añadir capa',
    newLayer: 'Nueva capa',
    dragReorder: 'Arrastra para reordenar',
    deleteLayer: 'Eliminar capa',
    cannotDeleteTitle: 'No se puede eliminar la capa',
    cannotDeleteLast: 'Una escena debe conservar al menos una capa. La última no se puede eliminar.',
    cannotDeleteNonEmpty:
      'Esta capa no está vacía. Limpia sus keyframes, tweens y objetos de escena antes de eliminarla.',
    tweenTitle: 'Tween: {start} - {end} ({easing})',
    frameTitle: 'Fotograma {frame}',
    frameDeleting: 'Fotograma {frame} (eliminando...)',
    addKeyframeAt: 'Añadir keyframe (Fotograma {frame})',
    addTweenShort: 'Añadir tween',
    clearAllKeyframes: 'Borrar todos los keyframes',
    clearAllTweens: 'Borrar todos los tweens',
  },
  stage: {
    selectionToolbar: 'Acciones del objeto',
    duplicate: 'Duplicar',
    createGroup: 'Crear grupo',
    createPattern: 'Crear patrón',
    ungroup: 'Desagrupar',
    removeFromGroup: 'Quitar del grupo',
    groupName: 'Grupo',
    insideThisLayer: 'Dentro de esta capa',
    bringToFront: 'Traer al frente',
    bringForward: 'Traer adelante',
    sendBackward: 'Enviar atrás',
    sendToBack: 'Enviar al fondo',
    sendToLayer: 'Enviar a capa',
    sendInto: 'Enviar dentro de',
    noSendIntoTargets: 'No hay objetos en esta capa',
    objectFallback: 'Objeto {id}',
    noLayers: 'Sin capas',
    layerFallback: 'Capa {id}',
    noLayerTitle: 'No hay capa seleccionada',
    noLayerDescription: 'Para añadir un objeto de escena, selecciona primero una capa.',
  },
  welcome: {
    title: 'Bienvenido',
    subtitle: 'Puedes crear un proyecto nuevo o seleccionar uno usado recientemente.',
    createProject: 'Crear nuevo proyecto',
    projectNamePlaceholder: 'Nombre del proyecto...',
    recentlyUsed: 'Usados recientemente',
    noRecent: 'No hay proyectos usados recientemente',
    myProjects: 'Mis proyectos',
    sampleProjects: 'Proyectos de ejemplo',
    empty: 'Aún no hay proyectos. ¡Empieza creando uno nuevo!',
    movieAria: 'película',
    previewTitle: 'Vista previa',
    openProject: 'Abrir proyecto',
    noDescription: 'Sin descripción',
    resolution: 'Resolución',
    fps: 'Velocidad de fotogramas',
    fpsValue: '{fps} fps',
    scenes: 'Escenas',
    sceneObjects: 'Objetos de escena',
    layers: 'Capas',
    sampleBadge: 'Ejemplo',
  },
  aiChat: {
    deleteMessage: 'Eliminar mensaje',
    thinking: 'Pensando...',
    jobs: 'Trabajos',
    actions: 'Acciones',
    payloads: 'Payloads',
    executionResults: 'Resultados de ejecución',
    loading: 'Cargando...',
    resizePanel: 'Redimensionar panel de chat',
    selectConversation: 'Seleccionar conversación',
    newChat: 'Nuevo chat',
    newChatTooltip: 'Nuevo chat',
    deleteConversation: 'Eliminar conversación',
    debugOn: 'Modo debug activado',
    debugOff: 'Modo debug desactivado',
    placeholder: 'Describe una escena ...',
    send: 'Enviar',
  },
  admin: {
    badge: 'Admin',
    backToEditor: 'Volver al editor',
    topbarTitle: 'Admin',
    a11y: {
      closeNav: 'Cerrar navegación',
      openNav: 'Abrir navegación',
    },
    nav: {
      dashboard: 'Panel',
      users: 'Usuarios',
      projects: 'Proyectos',
      activity: 'Actividad',
      activityDesc: 'SignalR · registro',
      activityTitle: 'Conexiones SignalR en vivo y registro de actividad',
      storageProviders: 'Proveedores de almacenamiento',
      socialProviders: 'Social Login',
      ai: 'IA',
      providers: 'Proveedores',
      prompts: 'Prompts',
      payment: 'Pagos',
      cryptoWallets: 'Monederos cripto',
      disclaimers: 'Avisos legales',
      install: 'Instalación',
      analytics: 'Analítica',
      settings: 'Ajustes',
      vectorPackages: 'Biblioteca pública',
    },
    vectorPackages: {
      title: 'Biblioteca pública',
      description: 'Biblioteca de la plataforma, compartida con cada proyecto. Importa un repositorio git o sube un zip. Cada carpeta es un paquete.',
      name: 'Nombre del paquete',
      file: 'Archivo del paquete',
      fileHint: 'Zip, SVG, PNG, WebP o JPEG. Un zip se descomprime en archivos sueltos.',
      upload: 'Subir paquete',
      uploading: 'Subiendo…',
      empty: 'La biblioteca pública está vacía.',
      files: '{count} archivos',
      delete: 'Eliminar',
      preview: 'Archivos',
      hide: 'Ocultar',
      deleteConfirm: '¿Eliminar "{name}" y sus archivos?',
      uploadFailed: 'Error al subir.',
      deleteFailed: 'No se pudo eliminar el paquete.',
      nameRequired: 'El nombre del paquete es obligatorio.',
      fileRequired: 'Elige un archivo de paquete.',
      loadFailed: 'No se pudo cargar la biblioteca pública.',
      gitUrl: 'URL del repositorio',
      gitBranch: 'Rama',
      gitPath: 'Carpeta',
      gitFormat: 'Formato',
      formatSvg: 'SVG',
      formatPng: 'PNG',
      gitHint: 'Solo HTTPS. Una carpeta como kits crea un paquete por subcarpeta. SVG y PNG no se importan juntos. Importar de nuevo actualiza esos paquetes.',
      gitImport: 'Importar repositorio',
      gitImporting: 'Importando…',
      gitImported: 'Se importaron {count} paquetes.',
      gitFailed: 'No se pudo importar el repositorio.',
      gitUrlRequired: 'La URL del repositorio es obligatoria.',
    },
  },
};
